import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { ALERT_BANNER_STORAGE_LIMIT_DISMISSED } from '~/constants/localStorageKeys';

const SESSION_STORAGE_KEY = 'air/alertBanner/storageLimitSessionDismissed';

type DismissedState = {
  isDismissed: boolean;
  dismiss: () => void;
};

/** Admin dismissal - persists per session (sessionStorage) */
export const useStorageLimitBannerSessionStore = create<DismissedState>()(
  persist(
    (set) => ({
      isDismissed: false,
      dismiss: () => set({ isDismissed: true }),
    }),
    {
      name: SESSION_STORAGE_KEY,
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

/** Non-admin dismissal - persists permanently (localStorage) */
export const useStorageLimitBannerPermanentStore = create<DismissedState>()(
  persist(
    (set) => ({
      isDismissed: false,
      dismiss: () => set({ isDismissed: true }),
    }),
    {
      name: ALERT_BANNER_STORAGE_LIMIT_DISMISSED,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
